// import logger from 'logger_module';
//import * as $ from 'jquery';
import { Util } from './util';
export class OnlineCheckHelper {

    static setOnlineService(serviceEndPoint: string = '') {
        this.onlineCheckService = serviceEndPoint;
    }

    static getOnlineService() {
        return this.onlineCheckService;
    }
    
    static getAjaxObj(config:any){
        return $.ajax(config);
    }

    static doOnlineAjaxCall(successCallback: () => void, params: string = '', failureCallback: () => void) {
        try {
            const url = this.getOnlineService() + '/online_check?' + params;
            this.getAjaxObj({
                url,
                headers: Util.getXApiKeyHeader(),
                success: () => {
                    this.onlineSuccess(successCallback);
                },
                error: () => {
                    this.onlineFailure(successCallback, params, failureCallback);
                }
            });
        } catch (e) {
            photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:OnlineCheckHelper:onlineCheckCall', errorCode: 'LIBRARY:OnlineCheckHelper', err_desc: e, err_stack: e.stack });
        }
    }

    /**
     * This method is the successcallback for online check
     * @param successCallback
     */
    static onlineSuccess(successCallback: () => void) {
        successCallback();
    }
    /**
     * This method is the failureCallback for online check which opens the layer
     * @param successCallback
     * @param params
     */
    static onlineFailure(successCallback: () => void, params: string = '', failureCallback: () => void) {
        if (failureCallback) {
            failureCallback();
        }
        setTimeout(() => {
            this.doOnlineAjaxCall(successCallback, '', failureCallback);
        }, 30000);
    }
    private static onlineCheckService: string = '';
}